export default __webpack_public_path__ + "static/media/reactjs.f3e576ba.png";